import { GlassCard } from '@/components/design/GlassCard';
import { NeonButton } from '@/components/design/NeonButton';
import { User, Bell, Lock, Moon, Globe } from 'lucide-react';
import { useState } from 'react';
import { Switch } from '@/components/ui/switch';

export const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
         <div>
          <h2 className="text-3xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-white/60">Settings</h2>
          <p className="text-muted-foreground">Manage your preferences and system config.</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        <GlassCard className="w-full md:w-64 p-4 h-fit">
          <nav className="space-y-2">
            {[
              { id: 'profile', label: 'Profile', icon: User },
              { id: 'notifications', label: 'Notifications', icon: Bell },
              { id: 'security', label: 'Security', icon: Lock },
              { id: 'appearance', label: 'Appearance', icon: Moon },
              { id: 'system', label: 'System', icon: Globe },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all ${
                  activeTab === item.id 
                    ? 'bg-primary/10 text-primary' 
                    : 'text-muted-foreground hover:bg-white/5 hover:text-white'
                }`}
              >
                <item.icon className="w-4 h-4" />
                <span className="font-medium text-sm">{item.label}</span>
              </button>
            ))}
          </nav>
        </GlassCard>

        <div className="flex-1 space-y-6">
          {activeTab === 'profile' && (
            <GlassCard>
              <h3 className="text-lg font-semibold mb-6">Profile Information</h3>
              <div className="flex items-start gap-6 mb-8">
                <div className="w-20 h-20 rounded-full bg-gradient-to-tr from-purple-500 to-pink-500 flex items-center justify-center text-3xl font-bold text-white shadow-neon">
                  AD
                </div>
                <div>
                  <h4 className="font-bold text-lg">Admin User</h4>
                  <p className="text-muted-foreground">Super Administrator</p>
                  <NeonButton size="sm" variant="secondary" className="mt-2">Change Avatar</NeonButton>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                 <div className="space-y-2">
                   <label className="text-xs font-medium text-muted-foreground uppercase">Full Name</label>
                   <input className="w-full bg-background/50 border border-white/10 rounded-lg px-3 py-2 text-sm" defaultValue="Admin User" />
                 </div>
                 <div className="space-y-2">
                   <label className="text-xs font-medium text-muted-foreground uppercase">Email Address</label>
                   <input className="w-full bg-background/50 border border-white/10 rounded-lg px-3 py-2 text-sm" defaultValue="admin@political.com" />
                 </div>
              </div>
              
              <div className="mt-6 flex justify-end">
                <NeonButton>Save Changes</NeonButton>
              </div>
            </GlassCard>
          )}

          {activeTab === 'notifications' && (
            <GlassCard>
              <h3 className="text-lg font-semibold mb-6">Notification Preferences</h3>
              <div className="space-y-6">
                {[
                  { title: 'New User Alerts', desc: 'Get notified when a new user registers.' },
                  { title: 'Post Comments', desc: 'Receive emails for new comments on posts.' },
                  { title: 'System Updates', desc: 'Important security and maintenance updates.' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center justify-between pb-4 border-b border-white/5 last:border-0">
                    <div>
                      <h4 className="font-medium text-white">{item.title}</h4>
                      <p className="text-sm text-muted-foreground">{item.desc}</p>
                    </div>
                    <Switch />
                  </div>
                ))}
              </div>
            </GlassCard>
          )}
        </div>
      </div>
    </div>
  );
};
